<template>
  <div class="contact-info">
    {{$t('contactInfo.header')}}
    <div class="octobus__columns">
      <div class="octobus__column is-two-thirds-desktop">
        <div class="octobus__columns">
          <div class="octobus__column">
            <div class="octobus__field">
              <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="contact-info__email">
                {{$t('contactInfo.email')}}
              </label>
              <p class="octobus__control has-icons-left has-icons-right">
                <input
                  :class="{
                    'is-danger': errors.has('contact-info__email'),
                    'is-primary': !errors.has('contact-info__email') && fields['contact-info__email'] && fields['contact-info__email'].dirty
                  }"
                  v-validate="'required|email'"
                  class="octobus__input is-medium"
                  type="email"
                  placeholder="Email"
                  id="contact-info__email"
                  name="contact-info__email"
                  :value="email"
                  @input="updateEmail($event.target.value)"
                >
                <span class="octobus__icon is-small is-left">
                  <font-awesome-icon
                    :icon="emailIcon"
                    :class="getClassValidate('contact-info__email')"
                  />
                </span>
              </p>
              <p v-show="errors.has('contact-info__email')" class="octobus__help is-danger">{{ errors.first('contact-info__email') }}</p>
            </div>
          </div>
          <div class="octobus__column">
            <div class="octobus__field is-horizontal">
              <div class="octobus__field-body">
                <div class="octobus__field is-expanded">
                  <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="contact-info__phone">
                    {{$t('contactInfo.phone')}}
                  </label>
                  <div class="octobus__field has-addons">
                    <p class="octobus__control">
                      <span class="octobus__select is-medium">
                        <select
                          :value="phone.country"
                          @input="updatePhone($event.target.value, 'country')"
                          :class="{
                            'is-danger': isError('contact-info__phone'),
                            'is-primary': isSuccess('contact-info__phone'),
                          }"
                        >
                          <option value="+38">+38</option>
                          <option value="+48">+48</option>
                          <option value="+49">+49</option>
                          <option value="+420">+420</option>
                          <option value="+55">+55</option>
                          <option value="+7">+7</option>
                          <option value="+31">+31</option>
                          <option value="+32">+32</option>
                          <option value="+33">+33</option>
                          <option value="+43">+43</option>
                          <option value="+34">+34</option>
                          <option value="+351">+351</option>
                          <option value="+41">+41</option>
                          <option value="+30">+30</option>
                          <option value="+355">+355</option>
                          <option value="+356">+356</option>
                          <option value="+357">+357</option>
                          <option value="+374">+374</option>
                          <option value="+381">+381</option>
                          <option value="+382">+382</option>
                          <option value="+385">+385</option>
                          <option value="+386">+386</option>
                          <option value="+387">+387</option>
                          <option value="+389">+389</option>
                          <option value="+39">+39</option>
                          <option value="+359">+359</option>
                          <option value="+36">+36</option>
                          <option value="+373">+373</option>
                          <option value="+375">+375</option>
                          <option value="+40">+40</option>
                          <option value="+421">+421</option>
                          <option value="+370">+370</option>
                          <option value="+371">+371</option>
                          <option value="+372">+372</option>
                          <option value="+44">+44</option>
                          <option value="+45">+45</option>
                          <option value="+46">+46</option>
                          <option value="+47">+47</option>
                          <option value="+353">+353</option>
                          <option value="+354">+354</option>
                          <option value="+358">+358</option>
                          <option value="+90">+90</option>
                        </select>
                      </span>
                    </p>
                    <p class="octobus__control is-expanded">
                      <input
                        :class="{
                          'is-danger': isError('contact-info__phone'),
                          'is-primary': isSuccess('contact-info__phone'),
                        }"
                        class="octobus__input is-medium"
                        type="tel"
                        :placeholder="$t('contactInfo.phoneInput')"
                        id="contact-info__phone"
                        name="contact-info__phone"
                        v-validate="'required'"
                        :value="phone.number"
                        v-mask="mask"
                        @input="updatePhone($event.target.value, 'number')"
                      >
                    </p>
                  </div>
                  <p v-show="errors.has('contact-info__phone')" class="octobus__help is-danger">{{ errors.first('contact-info__phone') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAuth" class="octobus__column is-one-thirds-desktop">
        <Promocode :tripId="tripId" />
      </div>
    </div>
    <div v-if="isPaysys">{{ $t('contactInfo.paysys-title') }}</div>
    <div class="octobus__columns" v-if="isPaysys">
      <div class="octobus__column">
        <div class="field" v-if="isLiqpay">
          <input class="is-checkradio" id="liqpay" type="radio" name="paysys" value="liqpay" @change="updatePaysys('liqpay')" :checked="paysys === 'liqpay'">
          <label for="liqpay">liqpay</label>
        </div>
        <div class="field" v-if="isFondy">
          <input class="is-checkradio" id="fondy" type="radio" name="paysys" value="fondy" @change="updatePaysys('fondy')" :checked="paysys === 'fondy'">
          <label for="fondy">fondy</label>
        </div>
        <div class="field" v-if="isWayforpay">
          <input class="is-checkradio" id="wayforpay" type="radio" name="paysys" value="wayforpay" @change="updatePaysys('wayforpay')" :checked="paysys === 'wayforpay'">
          <label for="wayforpay">wayforpay</label>
        </div>
        <div class="field" v-if="isYandex">
          <input class="is-checkradio" id="yandex" type="radio" name="paysys" value="yandex" @change="updatePaysys('yandex')" :checked="paysys === 'yandex'">
          <label for="yandex">Яндекс.Касса</label>
        </div>
        <div class="field" v-if="isPayU">
          <input class="is-checkradio" id="payu" type="radio" name="paysys" value="payu" @change="updatePaysys('payu')" :checked="paysys === 'payu'">
          <label for="payu">PayU</label>
        </div>
        <div class="field" v-if="isAdyen">
          <input class="is-checkradio" id="adyen" type="radio" name="paysys" value="adyen" @change="updatePaysys('adyen')" :checked="paysys === 'adyen'">
          <label for="adyen">Adyen</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faEnvelope } from '@fortawesome/fontawesome-free-solid';
import AwesomeMask from 'awesome-mask';
import { getMask } from '@/utils/utils';
import Promocode from './Promocode';

export default {
  name: 'ContactInfo',
  inject: ['$validator'], // like context
  directives: {
    mask: AwesomeMask,
  },
  components: {
    FontAwesomeIcon,
    Promocode,
  },
  props: {
    email: {
      type: String,
    },
    phone: {
      type: Object,
    },
    tripId: {
      type: String,
      required: true,
    },
    paysys: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    emailIcon() {
      return faEnvelope;
    },
    mask() {
      const phone = this.phone.country;
      const mask = getMask(phone);

      return mask;
    },
    isPaysys() {
      return this.$frameparams.paysys.length > 1;
    },
    isLiqpay() {
      return this.$frameparams.paysys.includes('liqpay');
    },
    isFondy() {
      return this.$frameparams.paysys.includes('fondy');
    },
    isWayforpay() {
      return this.$frameparams.paysys.includes('wayforpay');
    },
    isYandex() {
      return this.$frameparams.paysys.includes('yandex');
    },
    isPayU() {
      return this.$frameparams.paysys.includes('payu');
    },
    isAdyen() {
      return this.$frameparams.paysys.includes('adyen');
    },
    isAuth() {
      return this.$frameauth;
    },
  },
  methods: {
    updatePhone(value, type) {
      if (type === 'number') {
        const formattedValue = value.trim();

        this.$emit('changePhone', String(formattedValue), type);
        return true;
      }

      this.$emit('changePhone', String(value), type);
      return true;
    },
    updatePaysys(paysys) {
      this.$emit('paysys:changed', paysys);
    },
    updateEmail(value) {
      const formattedValue = value.trim();

      this.$emit('changeEmail', String(formattedValue));
    },
    isError(field) {
      return this.errors.has(field);
    },
    isSuccess(field) {
      return (
        !this.errors.has(field) &&
        this.fields[field] &&
        this.fields[field].dirty
      );
    },
    getClassValidate(field) {
      if (this.isError(field)) {
        return 'has-text-danger';
      }

      if (this.isSuccess(field)) {
        return 'has-text-primary';
      }

      return '';
    },
  },
};
</script>

<style scoped lang="scss">
#app, #auth {
  select {
    &.is-danger {
      border-color: #ff3860;
    }

    &.is-primary {
      border-color: #00d1b2;
    }
  }
}
/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {
}

.contact-info {
  & /deep/ .vue-phone-number-input.lg {
    .input-country-selector.lg {
      height: 45px;
      min-height: 45px;

      .country-selector__input {
        height: 45px;
        min-height: 45px;
      }
    }

    .input-phone-number.lg {
      height: 45px;
      min-height: 45px;

      .input-tel__input {
        height: 45px;
        min-height: 45px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ContactInfo/ContactInfo.vue